import api from './api';
import { fetchPage } from './pagedParams';

const purchaseOrderService = {

    // ── CRUD ──────────────────────────────────────────────

    createPurchaseOrder: async (data) => {
        const response = await api.post('/admin/purchase-orders', data);
        return response.data;
    },

    getPurchaseOrders: async () => {
        const response = await api.get('/admin/purchase-orders');
        return response.data;
    },

    getPurchaseOrderById: async (id) => {
        const response = await api.get(`/admin/purchase-orders/${id}`);
        return response.data;
    },

    // What's actually applied server-side depends on the PO's status:
    // DRAFT = everything (incl. items), SENT = notes only, RECEIVED/CANCELLED = rejected.
    updatePurchaseOrder: async (id, data) => {
        const response = await api.put(`/admin/purchase-orders/${id}`, data);
        return response.data;
    },

    // Backs the admin Supplier details page's purchase-order-history list.
    getPurchaseOrdersBySupplier: async (supplierId) => {
        const response = await api.get(`/admin/purchase-orders/by-supplier/${supplierId}`);
        return response.data;
    },

    // ── Lifecycle ─────────────────────────────────────────

    sendPurchaseOrder: async (id) => {
        const response = await api.put(`/admin/purchase-orders/${id}/send`);
        return response.data;
    },

    receivePurchaseOrder: async (id) => {
        const response = await api.put(`/admin/purchase-orders/${id}/receive`);
        return response.data;
    },

    cancelPurchaseOrder: async (id) => {
        const response = await api.put(`/admin/purchase-orders/${id}/cancel`);
        return response.data;
    },

    // ── Supporting data for the PO form ───────────────────

    getSuppliers: async () => {
        const response = await api.get('/admin/suppliers');
        return response.data;
    },

  // Server-side paged list (Spring Page) for the URL-driven DataTable.
  getPurchaseOrdersPage: (params) => fetchPage('/admin/purchase-orders/paged', params),

};

export default purchaseOrderService;